import React, {ChangeEvent, createRef, RefObject} from 'react';
import FullCalendar, { EventContentArg } from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid' // a plugin!
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import './PaymentCalendar.css'
import {TFunction, withTranslation} from "react-i18next";
import i18next from "i18next";
import {AxiosResponse} from "axios";
import esLocale from '@fullcalendar/core/locales/es';
import {SettlementService} from "../../services/SettlementService";
import {
    ICalendarTotals,
    ISettlementCalendarResponse, ISettlementCalendarRow
} from "../../models/ISettlementData";
import {DatesSetArg} from "@fullcalendar/core";
import {ITransaction} from "../../requests/ITransactionWebModelRequest";
import {IShortcutCaptureResult} from "../../models/IShortcut";
import {String} from "sugar";
import AccordionHeader from "react-bootstrap/AccordionHeader";
import Accordion from "react-bootstrap/Accordion";
import {Modal} from "react-bootstrap";
import AccordionBody from "react-bootstrap/AccordionBody";
import CalendarTotal from "./CalendarTotal";
import { CurrencyOption } from '../../models/Currency';
import { Option } from '../../models/Option';
import { UtilService } from '../../services/UtilService';
import { WebCache } from '../../services/WebCache';
import { Link } from 'react-router-dom';
import { OptionMapperHelper } from '../../helpers/OptionMapperHelper';
import SelectField from '../controls/fields/selectFieldNew';
import Button from '../controls/buttons/buttonNew';
import SubmitButton from '../controls/buttons/submitButtonNew';
import Form from '../containers/form';
import Card from '../containers/card';
import FormFilter, { FilterBlock } from '../containers/form-filterNew';
import Tooltip from '../Tooltip';
import { CurrencyHelper } from '../../helpers/CurrencyHelper';
import Page from '../containers/pageNew'
import FilterFiscalDocumentAndCommerce, { MultiSelectRef } from "../FilterFiscalDocumentAndCommerceNew";
import contraChargeAmountChart from "../charts/ContraChargeAmountChart";
import NavigationTabLinksForCalendar from './NavigationTabLinksForCalendar';
import CustomForm from '../containers/custom-form';
import { ReactComponent as IconInfoSVG } from "itd-common/assets/icons/alert-information.svg";
import './Calendar.scss';
interface IProps {
    t: TFunction
}
interface ICalendarEvent {
    title: string,
    start: string,
    end: string,
    paymentChargeAndReturnsFlag: boolean,
    additionalData: {
        statusColor: string,
        row: ISettlementCalendarRow
    }
}
interface IFilters {
    bankFilter:string,
    fiscalDocument: string[],
    merchantNumber: string[],
    bankBranchFilter:string,
    productFilter:string,
    selectedCurrency:string,
}
interface IState {
    filters:IFilters,
    initialized:boolean,
    weekendsVisible: boolean,
    rowDetail: {title:string,data:{ prop:string,value:string }[],total:string} |null,
    currentEvents:ICalendarEvent[],
    weekDayFormat: "short" | "long" | "narrow" | undefined,
    totalAmount:string[],
    paymentQuantity:number,
    conciliationAlarms:{days:string,quantity:number}[],
    conciliationTransactions:ITransaction[]|null
    columns:string[],
    settlementCurrency:string|null
    selectedSettlementDate:Date|null,
    filterAccordionRef:RefObject<any>
    settlementAccordionRef:RefObject<any>
    pressentedAccordionRef:RefObject<any>
    balanceAccordionRef:RefObject<any>
    calendarRef:RefObject<any>
    eventSelected:ICalendarTotals|null
    totals:ICalendarTotals,
    accordionRef:RefObject<any>,
    currencyOptions: CurrencyOption[],
    bankOptions: Option[],
    bankBranchOptions: Option[],
    productOptions: Option[],
    upToDate:boolean,
    selectedMonth:number,
    selectedYear:number,
    panelVisible: boolean,
    panelMode: "month" | "day"
}

const T_PREFIX: string = 'pages.calendar.';
let lastFiscalDocument:string=""
class PaymentCalendar extends React.Component<IProps, IState> {
    private multiSelectRef = createRef<MultiSelectRef>();
    private optionMapper: OptionMapperHelper = new OptionMapperHelper(this.props.t);

    constructor(props: IProps) {
        super(props);
        const currencyOptions = UtilService.getCurrencyOptions().filter(row => row.value !== "");
        // currencyOptions puede llegar vacío si aún no cargaron las monedas: evitamos quedar sin moneda seleccionada ("Seleccionar")
        const defaultCurrency = WebCache.isPosnetAppUser() ? '32' : (currencyOptions[0]?.value || (WebCache.getCurrentUser()?.countryId === 2 ? '858' : '32'));
        const allBanks = WebCache.getAllPayerBanks(true);
        const allProducts = WebCache.getAllProducts(true);
        const allBankBranches = WebCache.getAllPayerBankBranches(true);

        this.state = {
            upToDate:false,
            initialized:false,
            weekendsVisible: true,
            currentEvents:[],
            weekDayFormat: "short",
            rowDetail:null,
            totalAmount:[],
            conciliationAlarms:[],
            conciliationTransactions:null,
            columns:[],
            paymentQuantity:0,
            selectedSettlementDate:null,
            settlementCurrency:null,
            filterAccordionRef:React.createRef(),
            settlementAccordionRef:React.createRef(),
            pressentedAccordionRef:React.createRef(),
            balanceAccordionRef:React.createRef(),
            calendarRef:React.createRef(),
            totals:{
                currency:defaultCurrency,
                presentedAmount:0,
                settlementAmount:0,
                balanceAmount:0,
                settlementTariffAmount:0,
                presentedOthersAmount:0,
                presentedGrossAmount:0,
                presentedChargeAmount:0,
                presentedContapartAmount:0,
                settlementGrossAmount:0,
                settlementChargeAmount:0,
                settlementContapartAmount:0,
                settlementOthersAmount:0,
                settlementTaxAmount:0,
                couponsMovementsSum: 0,
                paymentAmount:0,
                addAmountCouponsMovementsSum:0,
                addAmountContrapartsMovementsSum: 0,
                representationsMovementsSum: 0,
                creditCouponsMovementsSum: 0,
                dtoLawSum: 0,
                netSaleFinancialDiscount:0
            },
            filters:{
                selectedCurrency: defaultCurrency,
                productFilter:allProducts[0].value,
                bankBranchFilter:allBankBranches[0].value,
                fiscalDocument: [""],
                merchantNumber:[""] ,
                bankFilter:allBanks[0].value
            },
            eventSelected:null,
            currencyOptions: currencyOptions,
            accordionRef:React.createRef(),
            bankOptions: allBanks,
            bankBranchOptions: allBankBranches,
            productOptions: allProducts,
            selectedMonth:new Date().getMonth(),
            selectedYear:new Date().getFullYear(),
            panelVisible: false,
            panelMode: "day"
        }
    }

    renderSidebar() {
        const { t } = this.props;
        return (
            <div >
                <div >
                    <h3>{t("payments")}: {this.state.paymentQuantity} Total :{this.state.totalAmount}</h3>
                </div>
            </div>
        )
    }

    handleWeekendsToggle = () => {
        this.setState({...this.state,
            weekendsVisible: !this.state.weekendsVisible
        })
    }

    private lastQueryDateTime: number = 0;

    buildTitleText =(currency:string,amount:number)=>{
        var text= CurrencyHelper.formatCurrencyAmount(currency, Number(amount)) + " "
        if(text.length>15)
            text=text.substring(0,12)+"...";
        return text;
    }

    buildCalendarTotals = (rows: ISettlementCalendarRow[], events: ICalendarEvent[], currency: string, targetMonth?: number, targetYear?: number): ICalendarTotals => {
        let balanceAmount = 0;
        let settlementAmount = 0;
        let presentedGrossAmount = 0;
        let presentedContapartAmount = 0;
        let presentedChargeAmount = 0;
        let presentedOthersAmount = 0;
        let presentedAmount = 0;
        let settlementGrossAmount = 0;
        let settlementTariffAmount=0;
        let settlementContapartAmount = 0;
        let couponsMovementsSum =0;
        let paymentAmount=0;
        let addAmountCouponsMovementsSum=0;
        let addAmountContrapartsMovementsSum=0;
        let representationsMovementsSum = 0;
        let creditCouponsMovementsSum = 0;
        let dtoLawSum=0;
        let netSaleFinancialDiscount=0;
        let settlementChargeAmount = 0;
        let settlementOthersAmount = 0;
        let settlementTaxAmount = 0;
        let currentDate = new Date();
        let pastCurrentDate = false;
        const GREEN = "#009B4A";
        //const YELLOW = "#F3B823";
        //const RED = "#DD3435";
        const ORANGE = "#F60";
        for (let row of rows) {
            const paymentDate = new Date(row.paymentDate);
            const isInTargetMonth = targetMonth === undefined || targetYear === undefined ? true : paymentDate.getMonth() === targetMonth && paymentDate.getFullYear() === targetYear;
            pastCurrentDate = new Date(row.paymentDate) >= currentDate;
            let statusColor = pastCurrentDate ? ORANGE : GREEN;
            if (row.settlementTotals.length > 0) {
                var conciliated = true;
                if (row.presentationTotals.length > 0) {
                    for (let presentationTotal of row.presentationTotals) {
                        if (presentationTotal.conciliatedTotalCount !== presentationTotal.totalCount) {
                            conciliated = false;
                            statusColor = pastCurrentDate ? ORANGE : GREEN;//RED;
                        }
                    }
                    if (!conciliated && isInTargetMonth) {//ajusto la diferencia entre presentado y liquidado cuando concilia
                        for (let presentationTotal of row.presentationTotals) {
                            presentedAmount += presentationTotal.netAmount;
                            presentedGrossAmount += presentationTotal.grossAmount;
                            presentedChargeAmount += presentationTotal.chargeAmount;
                            presentedContapartAmount += presentationTotal.contrapartAmount;
                        }
                    }
                }
                for (let settlementTotal of row.settlementTotals) {
                    if(isInTargetMonth) {
                        settlementTaxAmount += settlementTotal.taxAmount;
                        settlementAmount += settlementTotal.netAmount;
                        settlementGrossAmount += settlementTotal.grossAmount;
                        if(settlementTotal.tariffAmount!=null)
                            settlementTariffAmount+= settlementTotal.tariffAmount;
                        settlementChargeAmount += settlementTotal.chargeAmount;
                        settlementContapartAmount += settlementTotal.contrapartAmount;
                        couponsMovementsSum += settlementTotal.couponsMovementsSum;
                        paymentAmount +=settlementTotal.paymentAmount;
                        addAmountCouponsMovementsSum+=settlementTotal.addAmountCouponsMovementsSum;
                        addAmountContrapartsMovementsSum+=settlementTotal.addAmountContrapartsMovementsSum;
                        representationsMovementsSum += settlementTotal.representationsMovementsSum;
                        creditCouponsMovementsSum += settlementTotal.creditCouponsMovementsSum;
                        dtoLawSum +=settlementTotal.dtoLawSum;
                        netSaleFinancialDiscount+=settlementTotal.netSaleFinancialDiscount;
                        if (conciliated) {//ajusto la diferencia entre presentado y liquidado cuando concilia
                            presentedAmount += settlementTotal.netAmount;
                            presentedGrossAmount += settlementTotal.grossAmount;
                            presentedChargeAmount += settlementTotal.chargeAmount;
                            presentedContapartAmount += settlementTotal.contrapartAmount;
                        }
                    }

                    events.push({
                        additionalData: { statusColor, row },
                        title: this.buildTitleText(settlementTotal.currency,settlementTotal.netAmount),
                        start: row.paymentDate,
                        end: row.paymentDate.replace("T00","T23"),
                        paymentChargeAndReturnsFlag: settlementTotal.contrapartAmount!=0||settlementTotal.credVouchAmount!=0
                    });
                }
            } else if (row.presentationTotals.length > 0) {
                statusColor = pastCurrentDate ? ORANGE : "#DD3435";
                for (let settlementTotal of row.presentationTotals) {
                    presentedAmount += settlementTotal.netAmount;
                    presentedGrossAmount += settlementTotal.grossAmount;
                    presentedChargeAmount += settlementTotal.chargeAmount;
                    presentedContapartAmount += settlementTotal.contrapartAmount;
                    events.push({
                        additionalData: { statusColor, row },
                        title: this.buildTitleText(settlementTotal.currency,settlementTotal.netAmount),
                        start: row.paymentDate,
                        end: row.paymentDate.replace("T00","T23"),
                        paymentChargeAndReturnsFlag: settlementTotal.contrapartAmount!=0||settlementTotal.credVouchAmount!=0
                    });
                }
            } else {
                events.push({
                    additionalData: { statusColor:"#9B9B9B", row },
                    title: this.buildTitleText(currency,0),
                    start: row.paymentDate,
                    end: row.paymentDate.replace("T00","T23"),
                    paymentChargeAndReturnsFlag: false
                });
            }
        }

        balanceAmount = Math.abs(presentedAmount)-Math.abs(settlementAmount);
        if(couponsMovementsSum>0) // sacamos info de teradata
            settlementOthersAmount = settlementAmount-(couponsMovementsSum+addAmountCouponsMovementsSum+settlementContapartAmount+addAmountContrapartsMovementsSum-netSaleFinancialDiscount-settlementTariffAmount-settlementTaxAmount);
            //settlementOthersAmount = settlementAmount-(couponsMovementsSum+paymentAmount+addAmountCouponsMovementsSum+settlementContapartAmount+addAmountContrapartsMovementsSum+settlementChargeAmount+representationsMovementsSum+dtoLawSum+creditCouponsMovementsSum-netSaleFinancialDiscount-settlementTariffAmount-settlementTaxAmount);
        else if(settlementAmount<0)
            settlementOthersAmount = settlementAmount-Math.abs(settlementGrossAmount)+Math.abs(settlementTaxAmount)+Math.abs(settlementChargeAmount)+Math.abs(settlementContapartAmount)+Math.abs(settlementTariffAmount);
        else
            settlementOthersAmount = Math.abs(settlementAmount)-Math.abs(settlementGrossAmount)+Math.abs(settlementTaxAmount)+Math.abs(settlementChargeAmount)+Math.abs(settlementContapartAmount)+Math.abs(settlementTariffAmount);
        presentedOthersAmount = Math.abs(presentedAmount)-Math.abs(presentedGrossAmount)+Math.abs(presentedContapartAmount)+Math.abs(presentedChargeAmount);

        return {
            currency,
            presentedAmount,
            settlementAmount,
            balanceAmount,
            settlementTariffAmount,
            presentedOthersAmount,
            presentedGrossAmount,
            presentedChargeAmount,
            presentedContapartAmount,
            settlementGrossAmount,
            settlementChargeAmount,
            settlementContapartAmount,
            settlementOthersAmount,
            settlementTaxAmount,
            couponsMovementsSum,
            paymentAmount,
            addAmountCouponsMovementsSum,
            addAmountContrapartsMovementsSum,
            representationsMovementsSum,
            creditCouponsMovementsSum,
            dtoLawSum,
            netSaleFinancialDiscount
        };
    }

    getFromBuscar = () => {
        const calendarApi = this.state.calendarRef.current.getApi();
        const view = calendarApi.view;
        const datesSet: DatesSetArg = { start: view.activeStart, end: view.activeEnd } as DatesSetArg;
        this.calendarUpdatedInt(datesSet, this.state.filters.selectedCurrency); // Actualizar con la moneda seleccionada
    }

    calendarUpdated = (res:DatesSetArg) => {
        this.calendarUpdatedInt(res,this.state.filters.selectedCurrency);
    }

    calendarUpdatedInt = (res: DatesSetArg | null, selectedCurrency: string) => {
        if (res === null) {
            return;
        }

        let fromDate = res.start;
        let toDate = res.end;
        toDate.setDate(toDate.getDate() - 1);

        const referenceDate = new Date(fromDate);
        referenceDate.setDate(referenceDate.getDate() + 15);
        const targetMonth = referenceDate.getMonth();
        const targetYear = referenceDate.getFullYear();

        if (this.lastQueryDateTime < new Date().getTime() - 1000) {
            SettlementService.getSettlementCalendar({
                From: fromDate.toJSON(),
                To: toDate.toJSON(),
                Currency: this.state.filters.selectedCurrency,
                PayerEntity: (this.state.filters.bankFilter ?? "").replace("payingEntity-", ""),
                PayingEntityBranch: this.state.filters.bankBranchFilter,
                MerchantDocuments: this.state.filters.fiscalDocument.includes("all") ? [] : this.state.filters.fiscalDocument.filter(x=>x.length>0),
                MerchantNumbers: this.state.filters.merchantNumber.includes("all")? [] : this.state.filters.merchantNumber.filter(x=>x.length>0),
                ProductCode: (this.state.filters.productFilter ?? "").replace("productCode-", "")
            }).then((response: AxiosResponse<ISettlementCalendarResponse>) => {
                let events: ICalendarEvent[] = [];
                let totals = this.buildCalendarTotals(response.data.rows, events, selectedCurrency, targetMonth, targetYear); //llamo a la funcion con el mes y año elegido para que solo sume las liquidaciones de ese mes
                this.buildCalendarTotals(response.data.rows, events, selectedCurrency, undefined, undefined); //la llamo de nuevo para que tambien me traiga las liquidaciones de dias anteriores y posteriores al mes pero solo en la vista, no se suman al total liquidado
                this.setState({
                    totals,
                    upToDate:response.data.dataUpToDate,
                    currentEvents: events,
                    filters: {
                        ...this.state.filters,
                        selectedCurrency: selectedCurrency
                    },
                    selectedMonth: targetMonth,
                    selectedYear: targetYear
                });
            });
        }
        this.lastQueryDateTime = new Date().getTime();
    }
    handleEventClick = (clickInfo: any) => {
        if (clickInfo.event.extendedProps) {
            this.setState({
                selectedSettlementDate: new Date(clickInfo.event.extendedProps.additionalData.row.paymentDate),
                eventSelected: this.buildCalendarTotals([clickInfo.event.extendedProps.additionalData.row], [], this.state.totals.currency, undefined, undefined),
                panelVisible: true,
                panelMode: "day"
            });
        }
    }

    handleDayClick = (clickInfo: any) => {
        let eventFound = this.state.currentEvents.find((event) => event.start.startsWith(clickInfo.dateStr));
        this.handleEventClick({ event: { extendedProps: eventFound } });
    }

    renderEventContent = (eventInfo: EventContentArg) => {
        return (
            <div className="calendar-event-container">
                {/*
                    (eventInfo.event.extendedProps.paymentChargeAndReturnsFlag) ?
                        <Tooltip message={this.props.t('paymentChargeAndReturnsTooltip')}>
                            <i className="calendar-warning fas fa-exclamation-triangle text-warning"></i>
                        </Tooltip>
                        :
                        ''
                */}
                {!this.state.upToDate?<div className="calendar-status">{this.props.t('processing')}</div>:""}
                <div className="calendar-amount">{eventInfo.event.title}</div>
                <div className="calendar-div-status"
                     style={{backgroundColor: eventInfo.event.extendedProps.additionalData.statusColor}}></div>
            </div>
        )
    }

    handleCloseDialogClick = (event: any) => {
        event.preventDefault();
        this.setState({ eventSelected: null, panelVisible: false });
    }

    handleCurrencyChange = (event: ChangeEvent<HTMLSelectElement>) => {
        const selectedCurrency = event.target.value;
        this.setState(prevState => ({
            ...prevState,
            filters: {
                ...prevState.filters,
                selectedCurrency: selectedCurrency
            }
        }));
    }

    handleChange(event: ChangeEvent<HTMLSelectElement>): void {
        const target: HTMLSelectElement = event.target;
        const { name, value } = target;
        this.setState(prevState => ({
                ...prevState,
                selectedCurrency: value
            }), () => {
                if (name === "currencyFilter") {
                    this.getFromBuscar();
                } else {
                    this.setState({...this.state, [target.name]: target.value});
                }
            }
        );
    }

    handleMonthTotalClick = () => {
        this.setState({ panelVisible: true, panelMode: "month", eventSelected: null})
    }

    buildCalendarTotalByDayTitle = (): string => {
        const { t } = this.props;
        return t("calendarDayDetail");
    }


    getSettlementPath = (settlementCurrency: string | null) => {
        let captions:IShortcutCaptureResult[]=[];
        captions.push({data:this.state.settlementCurrency,description:"CURRENCY",type:"CURRENCY"})
        captions.push({data:{ year: (this.state.selectedSettlementDate+"").split("T")[0].split("-")[0],
                month: (this.state.selectedSettlementDate+"").split("T")[0].split("-")[1],
                day: (this.state.selectedSettlementDate+"").split("T")[0].split("-")[2]},description:"PAYMENT_DATE",type:"PAYMENT_DATE"})
        return "/reports/settlements?shortcuts="+String.escapeURL(JSON.stringify(captions));
    }

    buildSelectOptionsFromIdName(options: Array<{id: string, name: string}>) {
        return new OptionMapperHelper(this.props.t).buildSelectOptionsFromAnArrayWithDifferentInterface(options, 'id', 'name');
    }

    setFilters(filters: IFilters) {
        this.setState({ ...this.state, filters });
    }

    clearFilter = () => {
        this.multiSelectRef.current?.clearFilters();
        this.setState((prevState) => ({
            ...prevState,
            filters: {
                ...prevState.filters,
                productFilter:WebCache.getAllProducts(true)[0].value,
                bankBranchFilter:WebCache.getAllPayerBankBranches(true)[0].value,
                fiscalDocument:[""]/* WebCache.getAllMerchantDocuments(true,true)[0]?.label+"" */,
                merchantNumber:[""] ,
                bankFilter:WebCache.getAllPayerBanks(true)[0].value,
                selectedCurrency: WebCache.getCurrentUser()?.countryId === 2 ? '858' : '32'
            }
        }), () => {
            this.getFromBuscar();
        });
    }

    setFiscalSelected = (selected: any) => {
        this.setState((prevState) => ({
            filters: {
                ...prevState.filters,
                fiscalDocument: selected
            }}));
    };

    getMonthName = (monthNumber: number, year: number): string => {
        const date = new Date(year, monthNumber, 1);
        return new Intl.DateTimeFormat('es-ES', {month: 'long'}).format(date);
    }


    render() {
        const { t } = this.props;
        const currentUser = WebCache.getCurrentUser()?.countryId;
        let currencyFilter;

        if (currentUser !== undefined && currentUser === 2) {
            currencyFilter =  (<SelectField label={t("currency")} name="currency" options={this.state.currencyOptions}  onChange={this.handleCurrencyChange}  value={this.state.filters.selectedCurrency} />
            )
        } else {
            currencyFilter =  (<SelectField label={t("currency")} name="currency" options={this.state.currencyOptions}  onChange={this.handleCurrencyChange}  value={this.state.filters.selectedCurrency} />
            )
        }

        return (
            <Page>
                <>
                    <div className="calendar">
                        <div className="row">
                            <div className="col-md-12 box-title">
                                {!WebCache.isPosnetAppUser() && <h2>{t(`${T_PREFIX}paymentSchedule`)}</h2>}
                            </div>
                            <div className="col-md-12">
                                {!WebCache.isPosnetAppUser() && <p className="description">{t(`${T_PREFIX}description`)}</p>}
                            </div>
                            <div className="col-md-12">
                                {!WebCache.isPosnetAppUser() &&
                                    <div className="settlement-disclaimer">
                                        <IconInfoSVG className="settlement-disclaimer-icon"></IconInfoSVG>
                                        <span>{i18next.t("disclaimerSettlementTxt").toString()}</span>
                                    </div>
                                }
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-9 mt-2">
                                {!WebCache.isPosnetAppUser() &&<NavigationTabLinksForCalendar></NavigationTabLinksForCalendar>}
                            </div>
                            <div className="col-lg-3 mt-2 d-flex align-items-center justify-content-end">
                                <span className='me-1 currency-label'>
                                    {t('currency')}
                                </span>
                                <CustomForm
                                    model={[this.state.filters, this.setFilters.bind(this)]}>
                                    <SelectField attr='selectedCurrency' label='' options={this.state.currencyOptions} ></SelectField>
                                </CustomForm>
                            </div>
                        </div>
                        <div className="row">
                            {!WebCache.isPosnetAppUser() && 
                                <FormFilter page="paymentCalendar" model={[this.state.filters, this.setFilters.bind(this)]} onSubmit={this.getFromBuscar} clear={this.clearFilter} isAllFilterAvailable={false} hidden={UtilService.isMobilePlatform() ? true : false }
                                >
                                    <>
                                        <div className="row">
                                            <FilterBlock slot='primary' primaryClass='col-md-2' advancedClass="col-md-12 my-4">
                                                <SelectField attr='bankFilter' label='bank'
                                                    options={this.optionMapper.translateOptionValues(this.state.bankOptions)}></SelectField>
                                            </FilterBlock>
                                            <FilterFiscalDocumentAndCommerce
                                                changeFilter={(fiscalDocument, merchantNumber) => {
                                                    this.setState({
                                                        ...this.state,
                                                        filters: {
                                                            ...this.state.filters,
                                                            merchantNumber: merchantNumber,
                                                            fiscalDocument: fiscalDocument
                                                        }
                                                    });
                                                }}
                                                merchantDocumentConfig={{
                                                    advancedClass: "col-md-12 my-4",
                                                    primaryClass: "col-md-2",
                                                    slot: 'primary'
                                                }}
                                                fiscalDocumentConfig={{
                                                    advancedClass: "col-md-12 my-4",
                                                    primaryClass: "col-md-2",
                                                    slot: 'primary'
                                                }}
                                                includeAllFiscalDocument={true}
                                                includeWholesaler={true}
                                                ref={this.multiSelectRef}
                                            />
                                            <FilterBlock slot='primary' primaryClass='col-md-2' advancedClass="col-md-12 my-4">
                                                <SelectField attr='bankBranchFilter' label='branch'
                                                    options={this.optionMapper.translateOptionValues(this.state.bankBranchOptions)}></SelectField>
                                            </FilterBlock>
                                            <FilterBlock slot='primary' primaryClass='col-md-2' advancedClass="col-md-12 my-4">
                                                <SelectField attr='productFilter' label='brand'
                                                    options={this.optionMapper.translateOptionValues(this.state.productOptions)}></SelectField>
                                            </FilterBlock>
                                        </div>
                                    </>
                                </FormFilter>
                            }
                        </div>
                        <div className="row">
                            <div className={this.state.panelVisible ? "col-lg-9 px-0 notranslate" : "col-lg-12 px-0 notranslate"}>
                                <Card>
                                    <>
                                        <div className="row calendar-results-header">
                                            <div className="col-md-6 d-flex align-items-center">
                                                <h5>{t(`${T_PREFIX}searchResults`)}</h5>
                                            </div>
                                        </div>
                                        <div className="calendar-wrapper">
                                            <div className="calendar-month-total">
                                                <span className="calendar-month-total-label">{t(`${T_PREFIX}monthlySettlement`)}</span>
                                                <span className="calendar-month-total-amount cursor-pointer" onClick={this.handleMonthTotalClick}>
                                                    {this.buildTitleText(this.state.filters.selectedCurrency, this.state.totals.settlementAmount)}
                                                </span>
                                            </div>
                                            <FullCalendar
                                                ref={this.state.calendarRef}
                                                datesSet={this.calendarUpdated}
                                                plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                                                headerToolbar={{left: 'prev', center: 'title', right: 'next'}}
                                                locale={esLocale}
                                                initialView='dayGridMonth'
                                                dayHeaderFormat={{weekday: this.state.weekDayFormat}}
                                                editable={false}
                                                selectable={true}
                                                selectMirror={true}
                                                dayMaxEvents={true}
                                                weekends={this.state.weekendsVisible}
                                                events={this.state.currentEvents}
                                                //initialEvents={INITIAL_EVENTS} // alternatively, use the `events` setting to fetch from a feed
                                                //select={this.handleDateSelect}
                                                eventContent={this.renderEventContent} // custom render function
                                                eventClick={this.handleEventClick}
                                                dateClick={this.handleDayClick}
                                            //eventsSet={this.handleEvents} // called after events are initialized/added/changed/removed
                                            /* you can update a remote database when these fire:
                                            eventAdd={function(){}}
                                            eventRemove={function(){}}
                                            eventChange={function(){alert("ok")}}
                                            */
                                            />
                                            <div className="calendar-legend">
                                                <span className="calendar-legend-item">
                                                    <span className="calendar-legend-color" style={{ backgroundColor: "#009B4A" }}></span>
                                                    {t(`${T_PREFIX}settledAmounts`)}
                                                </span>
                                                <span className="calendar-legend-item">
                                                    <span className="calendar-legend-color" style={{ backgroundColor: "#F60" }}></span>
                                                    {t(`${T_PREFIX}pendingAmounts`)}
                                                </span>
                                            </div>
                                        </div>
                                    </>
                                </Card>
                            </div>
                            {this.state.panelVisible && (
                                <div className="col-lg-3 detail-cards">
                                    <CalendarTotal
                                        mode={this.state.panelMode}
                                        title={this.state.panelMode === "month" ? t(`${T_PREFIX}monthlySettlement`) : this.buildCalendarTotalByDayTitle()}
                                        totals={this.state.panelMode === "month" ? this.state.totals : this.state.eventSelected ?? this.state.totals}
                                        selectedDate={this.state.selectedSettlementDate}
                                        settlementPath={`/conciliation/settlementVouchers?shortcuts=${JSON.stringify([{
                                            type: "DATE",
                                            data: this.state.selectedSettlementDate
                                        }, { type: "CURRENCY", data: this.state.filters.selectedCurrency }])}`}
                                        onClose={this.handleCloseDialogClick}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                    <div>
                        {WebCache.isPosnetAppUser()?
                            <h6>{t("calendar.foot.messagePosnet")}</h6> 
                        :
                            <h6><i className="fas fa-exclamation-triangle text-warning imgCalendar"></i> {t("calendar.foot.message")}</h6>
                        }
                    </div>
                </>
            </Page>
        )
    };
}
export default withTranslation()(PaymentCalendar);
